import { useSelectedDeployment } from "@/features/deployment-selection/hooks/use-selected-deployment";
import { AnalyticsView } from "@/features/deployment-dashboard/analytics/analytics-view";
import { useAnalytics } from "@/features/deployment-dashboard/analytics/hooks/use-analytics";

export function AnalyticsContainer() {
  const { deploymentId } = useSelectedDeployment();
  const {
    filters,
    areas,
    onFiltersChange,
    onReset,
    populationTrend,
    dutyFreePopulationTrend,
    densityTrend,
    queueMetrics,
    throughputLineTrendData,
    throughputLineTrendLoading,
    throughputLineTrendError,
    throughputAllLineTrendData,
    throughputLines,
    throughputLinesLoading,
    throughputLinesError,
    selectedThroughputLineKeys,
    selectedThroughputLines,
    onThroughputLinesChange,
  } = useAnalytics({ deploymentId });

  return (
    <AnalyticsView
      deploymentId={deploymentId}
      filters={filters}
      areas={areas}
      onFiltersChange={onFiltersChange}
      onReset={onReset}
      populationTrend={populationTrend}
      dutyFreePopulationTrend={dutyFreePopulationTrend}
      densityTrend={densityTrend}
      queueMetrics={queueMetrics}
      throughputLineTrendData={throughputLineTrendData}
      throughputLineTrendLoading={throughputLineTrendLoading}
      throughputLineTrendError={throughputLineTrendError}
      throughputAllLineTrendData={throughputAllLineTrendData}
      throughputLines={throughputLines}
      throughputLinesLoading={throughputLinesLoading}
      throughputLinesError={throughputLinesError}
      selectedThroughputLineKeys={selectedThroughputLineKeys}
      selectedThroughputLines={selectedThroughputLines}
      onThroughputLinesChange={onThroughputLinesChange}
    />
  );
}
